<template>
<section class="home_content" @click="updateforChildren">
  <div class="content">
    <!-- Titres, sous-titres et introduction -->
    <h1>Cartoradio</h1>
    <p class="introduction">
      {{ $t("message['Retrouvez l emplacement des sites radioélectriques.']") }} <br />
      {{ $t("message['Consultez les mesures d exposition aux ondes sur tout le territoire français.']") }} <br />
      <span v-if="isPNSEActif">{{ $t("message['Consultez les cartes de simulation de l exposition aux ondes']") }}.<br /></span>
      {{ $t("message['Enregistrez vos propres cartes grâce au compte Mon Cartoradio.']") }} <br />
    </p>

    <!-- Bouton découvrir cartoradio -->
    <div>
      <a class="boutonDecouvrir boutonDecouvrirCartoradio" @click="lightbox_open">
        <img src="@/assets/img/play.svg" alt="play"/>
        cartoradio, comment ça marche ? Le tutoriel vidéo
      </a>

      <div id="light">
        <a class="boxclose" id="boxclose" @click="lightbox_close"></a>
        <video id="VisaChipCardVideo" width="600" controls>
          <source src="@/assets/video/screencast-anfr-v7.webm" type="video/webm">
          <source src="@/assets/video/screencast-anfr-v7.mp4" type="video/mp4">
          <!--Browser does not support <video> tag -->
        </video>
      </div>

      <div id="fade" @click="lightbox_close"></div>
    </div>

    <!-- Bouton découvrir simulations d'exposition -->
    <div v-if="isVideoPNSEVisible && isPNSEActif">
      <a class="boutonDecouvrir boutonDecouvrirSimulation" @click="lightboxSimulation_open">
        <img src="@/assets/img/play.svg" alt="play"/>
        SIMULATIONS D'EXPOSITION, COMMENT ÇA MARCHE ? LE TUTORIEL VIDÉO
      </a>

      <!-- Lightbox -->
      <div id="lightSimulation" v-if="videoPnseOpen">
        <a class="boxclose" id="boxclose" @click="lightboxSimulation_close"></a>
        <div class="video-container">
          <iframe
            title="video anfr"
            id="VisaChipCardIframe"
            :src="urlVideoPnse"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>
      </div>

      <!-- Background overlay -->
      <div id="fadeSimulation" @click="lightboxSimulation_close"></div>
    </div>

    <!-- Barre de recherche-->
    <search-adresse id="main_search_address_bar" class="home_search_bar" @lonlat="lonlat" Home='true' :goActive='goActive' @update-goActive="updateGoActive" @update-goActive-SearchBar-Off="updateGoActiveSearchBarOff" @update-goActive-SearchBar-On="updateGoActiveSearchBarOn"></search-adresse>

    <!-- 3 laius sur les fonctionnalités -->
    <div class="laius">
      <router-link to="/cartographie/stations" class="laius_stations">
        <img src="../assets/img/icon-stations.svg" alt="Icone Antenne" />
        <h3>{{ $tc("message['Sites radioélectriques']", 2) }}</h3>
        <p>{{ $t("message['Retrouvez toutes les stations radioélectriques : téléphonie mobile, TV, radio...']") }}</p>
      </router-link>
      <router-link to="/cartographie/mesures" class="laius_mesures">
        <img src="../assets/img/icon-mesures.svg" alt="Icone Fiche" />
        <h3>{{ $tc("message['Mesure']", 2) }}</h3>
        <p>{{ $t("message['Consultez les résultats des mesures d exposition aux ondes réalisées sur le terrain par un laboratoire accrédité']") }}</p>
      </router-link>
      <router-link v-if="isPNSEActif" to="/cartographie/simulations" class="laius_simulations">
        <div @click="trackRouterLinkClick('Simulations')">
          <img src="../assets/img/icon-simulations.png" alt="Icone Fiche"/>
          <h3>{{ $tc("message['Simulations']", 2) }}</h3>
          <p>{{ $t("message['Consultez les cartes de simulation de l exposition aux ondes']") }}</p>
        </div>
      </router-link>
      <button @click="monCartoradio" onclick="" class="connexion_modal laius_cartoradio">
        <img src="../assets/img/icon-mon-cartoradio.svg" alt="Icone Utilisateur" />
        <h3>{{ $t("message['Mon Cartoradio']") }}</h3>
        <p>{{ $t("message['Créez un compte pour sauvegarder vos cartes et télécharger vos données']") }}</p>
      </button>

    </div>
    <div class="infocarto">
        <p class="infocartotext">{{ $t("message['Retrouvez des données sur les sites et les mesures']") }}:</p>
        <a class="link infocartolink" href="https://www.anfr.fr/gestion-des-frequences-sites/lobservatoire/" target="_blank">{{ $t("message['Observatoire 2G/3G/4G']") }}</a>
        <a class="link infocartolink" href=" https://data.anfr.fr/accueil" target="_blank">{{ $t("message['Portail Open Data Anfr']") }}</a>
        <a class="link infocartolink" href=" https://www.data.gouv.fr/fr/organizations/agence-nationale-des-frequences/" target="_blank">{{ $t("message['Données Anfr data gouv']") }}</a>
    </div>
  </div>
</section>
</template>

<script>
import '../assets/css/home.css'
import SearchAdresse from './SearchAdresse.vue'

export default {
  name: 'Home',
  components: {
    SearchAdresse
  },
  computed: {
    isPNSEActif() {
      return this.$store.state.paramUrl.PNSE_ACTIF ? this.$store.state.paramUrl.PNSE_ACTIF === 'true' : false
    },
    isVideoPNSEVisible() {
      return this.$store.state.paramUrl.VIDEO_PNSE_VISIBLE ? this.$store.state.paramUrl.VIDEO_PNSE_VISIBLE === 'true' : false
    },
    urlVideoPnse() {
      return this.$store.state.paramUrl.VIDEO_PNSE_URL ? this.$store.state.paramUrl.VIDEO_PNSE_URL : ''
    }
  },
  methods: {
    trackRouterLinkClick(label) {
      window._paq.push(['trackEvent', 'Cartoradio', 'Accueil', label])
    },
    monCartoradio: function() {
      document.body.classList.add('moncr-em')
      // let loginPanel = document.getElementsByClassName('login')[0]
      // loginPanel.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
    },
    lonlat(lonlat) {
      this.$router.push('/cartographie/all/lonlat/' + lonlat.lon + '/' + lonlat.lat)
    },
    updateGoActive(status) {
      this.goActive = status
    },
    updateGoActiveSearchBarOff() {
      this.clickSearchBar = true
    },
    updateGoActiveSearchBarOn() {
      this.clickSearchBar = false
    },
    updateforChildren() {
      if (!this.clickSearchBar) {
        this.goActive = true
      }
    },

    lightbox_open() {
      var lightBoxVideo = document.getElementById('VisaChipCardVideo')
      window.scrollTo(0, 0)
      document.getElementById('light').style.display = 'block'
      document.getElementById('fade').style.display = 'block'

      lightBoxVideo.width = window.screen.width

      lightBoxVideo.play()
    },

    lightbox_close() {
      var lightBoxVideo = document.getElementById('VisaChipCardVideo')
      document.getElementById('light').style.display = 'none'
      document.getElementById('fade').style.display = 'none'
      lightBoxVideo.pause()
    },
    lightboxSimulation_open() {
      this.videoPnseOpen = true
      window.scrollTo(0, 0)
      document.getElementById('fadeSimulation').style.display = 'block'
    },
    lightboxSimulation_close() {
      this.videoPnseOpen = false
      document.getElementById('fadeSimulation').style.display = 'none'
    }
  },
  data() {
    return {
      goActive: true,
      clickSearchBar: false,
      showLightboxSimulation: false,
      videoPnseOpen: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
input.v-autocomplete-input {
  width: 100%;
  padding: 8px 10px;
  font-size: 1.1em;
}

 .v-autocomplete-list {
  width: 100%;
  max-height: 200px;
  overflow-y: scroll;
}

.infocarto {
  text-align: justify;
  margin: 0 5px 2px 70px;
  color: white;
  font-size: 0.9em;
  position: relative;
  bottom: 0;
  right: 10px;
  background-color: rgba(31, 81, 126, 0.6);
  margin-top: 2px;
  width:86%;
  overflow: hidden;
  padding-right:50px;
}

.infocartolink{
  text-decoration: underline;
  text-align: center;
  margin: 5px 10px 5px 0;
  color: white;
  font-size: 1.0em;
  position: relative;
  bottom: 0;
  right: 10px;
  float: left;
}

.infocartotext{
  float: left;
  margin: 5px 0 5px 100px;
  width: 375px;
}

.boutonDecouvrir {
  padding: 10px;
  background-color: rgba(150,59,214,0.9);
  color: #ffffff;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 600;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-content: center;
  line-height: 2em;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
}

.boutonDecouvrirCartoradio {
  width: 40%;
  max-width: 500px;
  margin-top: 50px;
}

.boutonDecouvrirSimulation {
  max-width: 550px;
  margin-top: 20px;
}

.boutonDecouvrir img {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

#light {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: -180px;
  border: 2px solid #FFF;
  background: #FFF;
  z-index: 1002;
  overflow: visible;
}

#light video {
  display: block;
  max-width: 100%    !important;
  max-height: 100%   !important;
}

#lightSimulation {
  display: block;
  position: fixed;
  top: 81%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -180px;
  border: 2px solid #FFF;
  background: #FFF;
  z-index: 1002;
  overflow: visible;
  width: 90%;
  max-width: 53vw;
}

/* Responsive iframe */
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.video-container iframe {
  position: absolute;
  //top: 0;
  //left: 0;
  width: 100%;
  height: 100%;
}

#light iframe {
  //display: block;
  //max-width: 100%    !important;
  //max-height: 100%   !important;
}

#boxclose {
  float: right;
  cursor: pointer;
  color: #fff;
  border: 1px solid #AEAEAE;
  border-radius: 3px;
  background: #222222;
  font-size: 31px;
  font-weight: bold;
  display: inline-block;
  line-height: 0px;
  padding: 11px 3px;
  position: absolute;
  right: 2px;
  top: 2px;
  z-index: 1002;
  opacity: 0.9;
}

#fade {
  display: none;
  position: fixed;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  background-color: black;
  z-index: 1001;
  -moz-opacity: 0.8;
  opacity: .80;
  filter: alpha(opacity=80);
}

.boxclose:before {
  content: "×";
}

#fade:hover ~ #boxclose {
  display:none;
}

#fadeSimulation {
  display: none;
  position: fixed;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  background-color: black;
  z-index: 1001;
  -moz-opacity: 0.8;
  opacity: .80;
  filter: alpha(opacity=80);
}

#fadeSimulation:hover ~ #boxclose {
  display:none;
}
</style>
